module.exports = __webpack_public_path__ + "media/images/pc/stores/yokohama/yokohama_concept_04-f76e40346d3339316bed9d36ff77648e.jpg";